
































































































import { Component, Vue, Prop } from "vue-property-decorator";
import sidebar from "@/components/englishjanala/sidebar.vue";
import Questions from "@/components/cards/ConversationQuestions.vue";
import NewQuestions from "@/components/modals/NewQuestion.vue";
import { Dialog, Popup, Notify } from "vant";
import axios from "axios";

import Spiner from "@/components/englishjanala/Spiner.vue";
import ExerciseHeader from "@/components/cards/ExerciseHeaderCard.vue";
// import { Chapter } from "@/model/englishjanala/englishjanala.ts";
import * as data from "@/model/englishjanala/englishjanala.json";
/* eslint-disable @typescript-eslint/class-name-casing */
/* eslint-disable @typescript-eslint/camelcase */

@Component({
  components: {
    NewQuestions,
    Questions,
    sidebar,
    Spiner,
    ExerciseHeader,
  },
})
export default class ExerciseHeaderCard extends Vue {
  @Prop() Exercise!: any;
  @Prop() edit_title!: any;

  EditTitle() {
    this.edit_title = true;
  }
}
